import { create } from 'zustand';
import i18n from '@/i18n';

interface LanguageState {
  language: string;
  setLanguage: (lang: string) => void;
}

export const useLanguageStore = create<LanguageState>((set) => ({
  language: i18n.language || 'en',
  setLanguage: (lang: string) => {
    i18n.changeLanguage(lang);
    set({ language: lang });
  },
}));

// Keep store in sync when i18n language changes externally
i18n.on('languageChanged', (lng) => {
  useLanguageStore.setState({ language: lng });
});
